import MDEditorRoot from "components/MDEditor/MDEditorRoot";
import { useMaterialUIController } from "context/materialUI-context/materialUI.context";
import { convertToHTML } from "draft-convert";
import { ContentState, EditorState, convertFromHTML } from "draft-js";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import cleanHtml from "utils/cleanHtml.util";

interface MDEditorShuttleProps {
  value: string;
  onChange: (content: string) => void;
  maxLength?: number;
}

const toolbarOptions = {
  options: ["emoji"],
};

const MDEditorShuttle: React.FC<MDEditorShuttleProps> = ({
  value,
  onChange,
  maxLength,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [editorState, setEditorState] = useState(() => {
    const sanitizedHtml = cleanHtml(value || "");
    const blocksFromHTML = convertFromHTML(sanitizedHtml);
    const content = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    return EditorState.createWithContent(content);
  });

  const [showAlert, setShowAlert] = useState(false);

  const handleEditorChange = (newEditorState: EditorState) => {
    const contentText = newEditorState.getCurrentContent().getPlainText();

    if (maxLength && contentText.length > maxLength) {
      setShowAlert(true);
      return;
    }

    setShowAlert(false);
    setEditorState(newEditorState);
    const html = convertToHTML(newEditorState.getCurrentContent());
    const cleanData = cleanHtml(html);
    onChange(cleanData);
  };

  useEffect(() => {
    const currentContent = editorState.getCurrentContent();
    const newSanitized = cleanHtml(value || "");
    const currentSanitized = cleanHtml(convertToHTML(currentContent));
  
    if (newSanitized !== currentSanitized) {
      const blocksFromHTML = convertFromHTML(newSanitized);
      const content = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const newState = EditorState.createWithContent(content);
      setEditorState(newState);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  
  return (
    <MDEditorRoot ownerState={{ darkMode }}>
      <Editor
        toolbar={toolbarOptions}
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        wrapperStyle={{
          minHeight: "130px",
        }}
        editorStyle={{
          lineHeight: '0.7',
          fontSize: '14px',
          minHeight: '130px',
        }}
      />
      <div
        style={{
          marginTop: 10,
          textAlign: "right",
          color: "#888",
          fontSize: "14px",
        }}
      >
        {showAlert && (
          <div style={{ color: "red" }}>Limite de caractères atteinte!</div>
        )}
        <span>
          {editorState.getCurrentContent().getPlainText().length} / {maxLength}
        </span>
      </div>
    </MDEditorRoot>
  );
};

export default MDEditorShuttle;
